import SashiDo from 'lib/SashiDo';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon/Icon.react';
import FormButton from 'components/FormButton/FormButton.react';
import styles from 'components/KeyField/KeyField.scss';
import CopyToClipboard from 'react-copy-to-clipboard';

import Tooltip from 'rc-tooltip';

export default class KeyField extends React.Component {
  constructor(props) {
    super();

    this.state = {
      copied: false,
      hidden: props.hidden,
      showEye: false,
    };
  }

  handleCopy() {
    setTimeout(() => this.setState({ copied: false }), 800);

    this.setState({
      copied: true,
    });
  }

  hide() {
    this.setState({
      hidden: true,
      showEye: false,
    });
  }

  show() {
    this.setState({
      hidden: false,
      showEye: true,
    });

    if (this.props.children.startsWith('mongodb://')) {
      Intercom('update', { show_db_url: true });
    }

    const eventType = this.props.name.toLowerCase().replace(' ', '_');

    if (eventType === 'pin_code') {
      SashiDo.activityTrack({ type: eventType });
    }
  }

  render() {
    let key = this.props.name || '';
    if (key.length) {
      key += ' ';
    }
    if (this.state.hidden) {
      return (
        <FormButton
          value={this.props.whenHiddenText || `Show ${key}`}
          onClick={this.show.bind(this)} />
      );
    }

    const classes = [styles.copy, this.state.copied ? styles.active : null];

    return (
      <div className={[styles.key, this.state.showEye ? styles.showEye : null].join(' ')}>
        {this.state.showEye
          ? <div className={styles.view} onClick={this.hide.bind(this)}>
            <Icon name="icon-eye-slash" width={16} height={16} />
          </div>
          : null
        }

        <span className={styles.code}>
          {
            this.props.isHypeLink
              ? (
                <a href={this.props.children} alt={this.props.children} target="_blank">{this.props.children}</a>
              )
              : this.props.children
          }
        </span>

        <CopyToClipboard text={this.props.children}
          onCopy={this.handleCopy.bind(this)}>
          <Tooltip placement="right" overlay="Copy to Clipboard" arrowContent={<div className="rc-tooltip-arrow-inner" />}>
            <span className={classes.join(' ')}>
              {this.state.copied
                ? <Icon name="icon-check" width={16} height={16} />
                : <Icon name="icon-copy" width={16} height={16} />
              }
            </span>
          </Tooltip>
        </CopyToClipboard>
      </div>
    );
  }
}

KeyField.propTypes = {
  children: PropTypes.node,
  hidden: PropTypes.bool,
  name: PropTypes.string,
  whenHiddenText: PropTypes.string,
};
